import { useEffect, useState, useRef } from "react";
import config from "../../config";
import BookingModal from './BookingModal';
import CheckTimeSlots from "./CheckTimeSlots";
import InteractiveDesks from "./InteractiveDesks";
import { scrollToTarget } from '../../utils/scrollUtils';
import { timeToMinutes, minutesToTime, dateInSpain } from "../../utils/timeUtils";
import {  toZonedTime } from 'date-fns-tz';

/* TESTING */
/* Switch dates in calculateInitialDate and generateTimeSlots */
/* Find word TESTING in file */
const [tYear, tMonth, tDay, tHour, tMinute] = [2025, 2, 24, 8, 29]; // [2025, 2, 15, 14, 30] -> 15/03/2025 14h30
const timeZone = 'Europe/Madrid';

const desks_1200w = [
  { ResourceId: 'D1', Available: false, x: -49, y: 71 },
  { ResourceId: 'D2', Available: false, x: -22, y: 71 },
  { ResourceId: 'D3', Available: false, x: 5.5, y: 71 },
  { ResourceId: 'D4', Available: false, x: -36, y: 110 },
  { ResourceId: 'D5', Available: false, x: -7, y: 110 },
  { ResourceId: 'D6', Available: false, x: 92, y: 135},
  { ResourceId: 'D7', Available: false, x: 92, y: 160 },
  { ResourceId: 'D8', Available: false, x: 92, y: 185 },
  { ResourceId: 'D9', Available: false, x: 51, y: 146 },
  { ResourceId: 'D10', Available: false, x: 51, y: 173 },
  { ResourceId: 'C1', Available: false, x: -27, y: 11 },
  { ResourceId: 'C2', Available: false, x: -9, y: 11 }
];

const desks_1000w = [
  { ResourceId: 'D1', Available: false, x: -16, y: 46 },
  { ResourceId: 'D2', Available: false, x: 1.75, y: 46 },
  { ResourceId: 'D3', Available: false, x: 20.5, y: 46 },
  { ResourceId: 'D4', Available: false, x: -8, y: 72 },
  { ResourceId: 'D5', Available: false, x: 12, y: 72 },
  { ResourceId: 'D6', Available: false, x: 78, y: 88},
  { ResourceId: 'D7', Available: false, x: 78, y: 105 },
  { ResourceId: 'D8', Available: false, x: 78, y: 121.75 },
  { ResourceId: 'D9', Available: false, x: 51, y: 96 },
  { ResourceId: 'D10', Available: false, x: 51, y: 114.5 },
  { ResourceId: 'C1', Available: false, x: -2, y: 6 },
  { ResourceId: 'C2', Available: false, x: 10, y: 6 }
];

const desks_600w = [
  { ResourceId: 'D1', Available: false, x: 0.75, y: 33.5 },
  { ResourceId: 'D2', Available: false, x: 13.75, y: 33.5 },
  { ResourceId: 'D3', Available: false, x: 27.75, y: 33.5 },
  { ResourceId: 'D4', Available: false, x: 6.5, y: 53 },
  { ResourceId: 'D5', Available: false, x: 21.5, y: 53 },
  { ResourceId: 'D6', Available: false, x: 70, y: 65 },
  { ResourceId: 'D7', Available: false, x: 70, y: 77.75 },
  { ResourceId: 'D8', Available: false, x: 70, y: 90.25 },
  { ResourceId: 'D9', Available: false, x: 51, y: 70.75 },
  { ResourceId: 'D10', Available: false, x: 51, y: 84.375 },
  { ResourceId: 'C1', Available: false, x: 11, y: 4 },
  { ResourceId: 'C2', Available: false, x: 20.5, y: 4 }
];

const desks_300w = [
  { ResourceId: 'D1', Available: false, x: 18.5, y: 40 },
  { ResourceId: 'D2', Available: false, x: 26.5, y: 40 },
  { ResourceId: 'D3', Available: false, x: 35, y: 40 },
  { ResourceId: 'D4', Available: false, x: 22, y: 51 },
  { ResourceId: 'D5', Available: false, x: 31.5, y: 51 },
  { ResourceId: 'D6', Available: false, x: 61, y: 59 },
  { ResourceId: 'D7', Available: false, x: 61, y: 67 },
  { ResourceId: 'D8', Available: false, x: 61, y: 75 },
  { ResourceId: 'D9', Available: false, x: 50, y: 63 },
  { ResourceId: 'D10', Available: false, x: 50, y: 71 },
  { ResourceId: 'C1', Available: false, x: 24, y: 21 },
  { ResourceId: 'C2', Available: false, x: 32, y: 21 }
];

const BookingForm = ({ t }) => {
    const text1=t("pages.booking_new.texts.text1", { returnObjects: true });
    const text2=t("pages.booking_new.texts.text2", { returnObjects: true });
    const text3=t("pages.booking_new.texts.text3", { returnObjects: true });
    const text4=t("pages.booking_new.texts.text4", { returnObjects: true });
    const buttonText=t("pages.booking_new.texts.text5", { returnObjects: true });
    const text6=t("pages.booking_new.texts.text6", { returnObjects: true });
    const text7=t("pages.booking_new.texts.text7", { returnObjects: true });
    const text8=t("pages.booking_new.texts.text8", { returnObjects: true });
    const text9=t("pages.booking_new.texts.text9", { returnObjects: true });
    const text10=t("pages.booking_new.texts.text10", { returnObjects: true });
    const text11=t("pages.booking_new.texts.text11", { returnObjects: true });


    const handleSubmit = (e) => {
      e.preventDefault();
      setIsModalOpen(true);
    };
  
    const closeModal = (refresh = true) => {
      if(refresh) {
        setRefreshTimeSlots(prev => prev === '1' ? '0' : '1'); // Update TimeSlots
      }
      setIsModalOpen(false);
      scrollToTarget("booking-form");
    };

    const handleCurrentBookingDateChange = (e) => {
      setDate(e.target.value);

      const timeSlots = generateTimeSlots(config.globalStartHour, config.globalEndHour, e.target.value);
      setStartTime(timeSlots[0]);

      setCurrentBooking(prevCurrentBooking => ({
        ...prevCurrentBooking,
        Date: e.target.value
      }));
    };

    const handleTimeSlotStartChange = (e) => {
      let start;
      
      if (e.target.type === 'range') {
          const index = e.target.value;
          start = timeSlots[index];
      } else {
          start = e.target.value;
      }

      document.getElementById("start-time").value = start;
      document.getElementById("start-time-range").value = timeSlots.indexOf(start);
      setStartTime(start);

      const end = minutesToTime(timeToMinutes(start) + config.globalMinimumTimeSlot * 60);
      const timeSlotsBetween = generateTimeSlotsBetween(start, end);

      const cabinEnd = minutesToTime(timeToMinutes(start) + config.globalTimeCabinSlot * 60);
      const cabinTimeSlotsBetween = generateTimeSlotsBetween(start, cabinEnd);

      setCurrentBooking(prevCurrentBooking => ({
        ...prevCurrentBooking,
        TimeSlots: timeSlotsBetween,
        CabinTimeSlots: cabinTimeSlotsBetween
      }));
  };
        
    const [desk, setDesk] = useState("");
    const [isAvailable, setIsAvailable] = useState();

    const initialDate = calculateInitialDate();
    const [date, setDate] = useState(initialDate);

    const timeSlots = generateTimeSlots(config.globalStartHour, config.globalEndHour, date);
    const [startTime, setStartTime] = useState(timeSlots[0]);
    useEffect(() => {
      if (startTime) {
          handleTimeSlotStartChange({ target: { value: startTime } });
      }
    }, [startTime]);

    const [output, setOutput] = useState([]);
    const [currentBooking, setCurrentBooking] = useState({ Date: date, TimeSlots: generateTimeSlotsBetween(startTime, config.globalEndHour), CabinTimeSlots: generateTimeSlotsBetween(startTime, config.globalEndHour) });
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [refreshTimeSlots, setRefreshTimeSlots] = useState('');

    const [desks, setDesks] = useState(getDesksAccordingToScreenWidth(window.innerWidth));
    useEffect(() => {
      const handleResize = () => {
        setDesks(getDesksAccordingToScreenWidth(window.innerWidth));
      };

      window.addEventListener("resize", handleResize);
      handleResize();

      return () => window.removeEventListener("resize", handleResize);
    }, []);

    const [loading, setLoading] = useState(false);

    const dateInputRef = useRef(null);

    const handleClick = () => {
      if (dateInputRef.current) {
        dateInputRef.current.showPicker();
      }
    };

    return (
      <>
        <form id="booking-form" className="booking-form" onSubmit={handleSubmit}>
          <div className="booking-form-header">
            <h2 className="booking-form-title">{text1}</h2>
            <div className="generic-separator-mobile" />
            <p className="booking-form-header-p" onClick={() => scrollToTarget("booking-overview-form")}>{text11} ⇩</p>
            <div className="generic-separator-web" />
          </div>

          <p className="booking-form-p">{text10}</p>
          
          <div className="booking-form-group-map">
            <div className="booking-form-group">
              <div className="booking-form-row-2">
                <div className="booking-form-time-container">
                  <input id="start-date" type="date" ref={dateInputRef} placeholder={text2} defaultValue={date} onChange={handleCurrentBookingDateChange} min={initialDate} onClick={handleClick}/>
                  <select id="start-time" defaultValue={timeSlots[0]} onChange={handleTimeSlotStartChange}>
                    {timeSlots.filter((time) => timeToMinutes(time) !== timeToMinutes(config.globalEndHour + ":00")).map((time, index) => (
                      <option key={index} value={time}>{time}</option>
                    ))}
                  </select>
                </div>
                <div className="booking-form-range-container">
                  <input id="start-time-range" type="range" min="0" max={timeSlots.length - 2} step="1" defaultValue={timeSlots[0]} onChange={handleTimeSlotStartChange}/>
                </div>
              </div>
            </div>

            <CheckTimeSlots currentBooking={currentBooking} onOutputChange={setOutput} refreshTimeSlots={refreshTimeSlots} setLoading={setLoading}/>
            <InteractiveDesks 
              desks={desks} 
              output={output} 
              setIsModalOpen={setIsModalOpen} 
              inputDesk={desk} 
              handleDeskChange={setDesk} 
              setIsAvailable={setIsAvailable} 
              arePointsActive={!(date && startTime)}
              loading={loading}
            />
          </div>
        </form>
        {isModalOpen && <BookingModal 
          t={t} 
          booking={{StartDate: date, EndDate: date, StartTime: startTime, ResourceId:desk}}
          isAvailable={isAvailable} 
          onClose={closeModal}
          origin={"new"}
          startTimeForm={startTime}
          timeSlots={timeSlots}
        />}
      </>
    );
  };
  
  export default BookingForm;

const generateTimeSlots = (minHour, maxHour, selectedDate) => {
  const slots = [];
  let customMinHour = minHour;
  let startMinute = 0;

  //const currentDate = new Date(tYear, tMonth, tDay, tHour, tMinute); // TESTING
  const currentDate = dateInSpain();
  const currentHour = currentDate.getHours();
  const currentMinute = currentDate.getMinutes();

  if (currentHour >= maxHour) {
    customMinHour = minHour;
  } else if (selectedDate === currentDate.toISOString().split('T')[0]) {
    if (currentHour >= minHour && currentHour < maxHour) {
      customMinHour = currentHour;
      startMinute = currentMinute >= 30 ? 30 : 0;
    }
  }

  for (let h = customMinHour; h <= maxHour; h++) {
    if (h === customMinHour && startMinute === 30) {
      slots.push(`${h.toString().padStart(2, "0")}:30`);
    } else {
      slots.push(`${h.toString().padStart(2, "0")}:00`);
      if (h !== maxHour) slots.push(`${h.toString().padStart(2, "0")}:30`);
    }
  }
  return slots;
};

const generateTimeSlotsBetween = (start, end) => {
  const timeSlots = [];
  let current = toZonedTime(new Date(`1970-01-01T${start}:00`), timeZone);
  const adjustedEnd = end ? clampTimeToMax(end) : '';
  const endTime = toZonedTime(new Date(`1970-01-01T${adjustedEnd}:00`), timeZone);
  
  while (current < endTime) {
    timeSlots.push(current.toTimeString().slice(0, 5));
    current = new Date(current.getTime() + 30 * 60000); // Increment by 30 minutes
  }
  return timeSlots;
};

const clampTimeToMax = (inputTime, maxTime = "23:30") => {
  if (typeof inputTime !== 'string') {
    return maxTime;
  }

  const [inputHour, inputMinute] = inputTime.split(":").map(Number);
  const [maxHour, maxMinute] = maxTime.split(":").map(Number);

  // If inputTime is invalid or exceeds 23:59, force it to maxTime
  if (
    isNaN(inputHour) || isNaN(inputMinute) ||
    inputHour > 23 || inputMinute > 59 ||
    inputHour > maxHour ||
    (inputHour === maxHour && inputMinute > maxMinute)
  ) {
    return maxTime;
  }

  return inputTime;
};

const calculateInitialDate = () => {
  //const now = new Date(tYear, tMonth, tDay, tHour, tMinute); // TESTING
  const now = dateInSpain();
  const currentHour = now.getHours();
  const today = now.toISOString().split('T')[0];

  now.setDate(now.getDate() + 1);
  const tomorrow = now.toISOString().split('T')[0];

  // Allow same-day reservations until the last possible hour
  return currentHour < (config.globalEndHour) ? today : tomorrow;
};

const getDesksAccordingToScreenWidth = (screenWidth) => {
  if (screenWidth <= 500) {
    return desks_300w;
  } else if (screenWidth <= 1200) {
    return desks_600w;
  } else if (screenWidth <= 1600) {
    return desks_1000w;
  } else {
    return desks_1200w;
  }
}